export const ROLES = {
  OWNER: 'owner',
  OPERATOR: 'operator',
  AUTHORIZED: 'authorized',
} as const;

export const MAP_ROLE_TO_I18_KEY = {
  [ROLES.OWNER]: 'profile:role.owner',
  [ROLES.OPERATOR]: 'profile:role.operator',
  [ROLES.AUTHORIZED]: 'profile:role.authorized',
} as const;
